const datatable = {

}

export default {
  dashboard: {

  }
}
